<template>
    <v-container fluid class="fill-height">
        <v-row>
            <v-col>
                <div class="contain" @contextmenu.prevent="showAddMenu" id="printTest" ref="dragContain">
                    <v-menu
                        v-model="addMenu"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                    >
                        <v-list dense>
                            <v-list-item-group color="primary">
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title @click="addDive">添加座位</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>

                    <div v-drag="contain" class="drag" :class="{active:divindex != 0 && index == divindex}"
                         v-if="json.length"
                         v-for="(item,index) in json" @click="moveDiv(index,$event)" :style="item.style">
                        {{item.text}}
                        <i class="el-icon-menu sacle" v-if="index == divindex && divindex == 0" @click="sacle($event)"
                           @mousedown="mouseDown($event,true)" unselectable="on"></i>
                        <v-icon class="del" color="red" v-if="item.delShow && index == divindex" small
                                @click="del(index,$event)">mdi-delete
                        </v-icon>
                        <!--<el-button type="danger" class="del"  v-if="index == divindex"
                                   icon="el-icon-delete" circle></el-button>-->
                    </div>
                    <!--<div v-if="!json.length">暂时没有内容哦！！期待您的编辑</div>-->
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-btn @click="onSave">保存模板</v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    export default {
        name: "SeatTemplate",
        data() {
            return {
                id: '',
                addMenu: false,
                json: [],
                name: "",
                //菜单位置
                x: 0,
                y: 0,
                //块位置
                offsetX: 0,
                offsetY: 0,
                //外层容器的宽高 数值不带px单位
                contain: {
                    xx: 500,
                    yy: 500
                },
                //存放拉伸放大时的  div的原始宽高 带px单位
                movejson: {
                    moveWidth: '',
                    moveHeight: ''
                },
                divindex: 0,//当前选中div的序号  默认为0
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if(!this.id){
                this.$dialog.alert("请先选择教室");
                this.$router.push("/room");
                return
            }
            this.contain.xx = this.$refs.dragContain.offsetWidth;
            this.contain.yy = this.$refs.dragContain.offsetHeight;
            this.$api.bizClassRoom.selectClassRoom(this.id).then(data => {
                this.json = JSON.parse(data.data.model);
            });
        },
        methods: {
            // 字符串转json对象
            toJson(str) {
                let _str = eval('(' + str + ')');
                return _str;
            },
            //外层div点击选择事件 绑定右上角设置面板
            moveDiv(index, e) {
                let jsonNew = this.toJson('{"' + e.target.style.cssText.replace(/\; +/g, "\",\"").replace(/\: +/g, "\":\"").replace(/\;+/g, "").replace(/-\w/g, function ($) {
                    return $.slice(1).toUpperCase();
                }) + '"}');
                //当前选中div的序号
                this.divindex = index;

                // 设置div框的 各种属性
                for (let em in jsonNew) {
                    this.json[index].style[em] = jsonNew[em];
                }
                this.json[index].text = e.target.innerText;

            },
            //添加一个div块 默认的
            addDive() {
                let newJson = {
                    style: {
                        width: "60px",
                        height: "80px",
                        fontSize: "14px",
                        color: "#ffffff",
                        top: this.gridCalc(this.offsetY) + "px",
                        left: this.gridCalc(this.offsetX) + "px",
                        border: "1px solid rgb(0, 0, 0)",
                        backgroundColor: "rgb(255, 255, 255)",
                        borderRadius: "5px"
                    },
                    text: '',
                    delShow: true
                };
                this.json.push(newJson);
            },
            //删除当前div
            del(i, e) {
                this.json.splice(i, 1);
                // console.log(i,this.json.length)
                if (i == this.json.length) {
                    this.divindex = 0;
                }
                e.stopPropagation();
            },
            onSave() {
                // console.log(this.json,'11')
                let data = this.json;
                //console.log(JSON.stringify(data))
                this.$api.bizClassRoom.updateClassRoom({
                    id: this.id,
                    model: JSON.stringify(data)
                }).then(obj => {
                    if (obj.flag) {
                        this.$router.push("/room");
                    }
                })
            },
            //div上拉伸的阻止冒泡事件
            sacle(e) {
                e.stopPropagation();
            },
            //div上拉伸的 放大 缩小div宽高
            mouseDown(e, type) {
                if (type) {
                    let that = this;
                    let oldX = e.pageX, oldY = e.pageY;
                    that.movejson.moveWidth = that.json[that.divindex].style.width;
                    that.movejson.moveHeight = that.json[that.divindex].style.height;
                    document.onmousemove = function (e) {
                        let newX = e.pageX - oldX;
                        let newY = e.pageY - oldY;
                        newX = that.gridCalc(newX)
                        newY = that.gridCalc(newY)
                        that.json[that.divindex].style.width = ((newX + parseInt(that.movejson.moveWidth)) >= 80 ? (newX + parseInt(that.movejson.moveWidth)) : '80') + 'px';
                        that.json[that.divindex].style.height = ((newY + parseInt(that.movejson.moveHeight)) >= 40 ? (newY + parseInt(that.movejson.moveHeight)) : '40') + 'px';
                        that.json[that.divindex].style.fontSize = parseInt(that.json[that.divindex].style.width.substring(0, that.json[that.divindex].style.width.length - 2) * 0.1 + that.json[that.divindex].style.height.substring(0, that.json[that.divindex].style.height.length - 2) * 0.1) + "px";
                    }
                    document.onmouseup = function () {
                        document.onmousemove = document.onmouseup = null;
                    }
                }
                e.stopPropagation();
            },
            showAddMenu(e) {
                this.x = e.clientX
                this.y = e.clientY
                this.offsetX = e.offsetX
                this.offsetY = e.offsetY
                this.addMenu = true
            },
            gridCalc(num) {
                return Math.floor((num + 5) / 10) * 10
            }
        },
        computed: {},
        directives: {
            drag: {
                bind: function (el, binding, vnode) {
                    el.onmousedown = (e) => {
                        var disx = e.clientX - el.offsetLeft;
                        var disy = e.clientY - el.offsetTop;
                        document.onmousemove = function (e) {
                            let left = e.clientX - disx;
                            let top = e.clientY - disy;
                            if (left < 0) {
                                left = 0;
                            }
                            if (top < 0) {
                                top = 0;
                            }
                            if (left > binding.value.xx - el.offsetWidth) {
                                left = binding.value.xx - el.offsetWidth;
                            }
                            if (top > binding.value.yy - el.offsetHeight) {
                                top = binding.value.yy - el.offsetHeight;
                            }
                            left = Math.floor((left + 5) / 10) * 10;
                            top = Math.floor((top + 5) / 10) * 10;
                            el.style.left = left + 'px';
                            el.style.top = top + 'px';
                        }
                        document.onmouseup = function () {
                            document.onmousemove = document.onmouseup = null;
                        }
                    }

                },

            }
        }
    }
</script>

<style lang='scss' scoped>
    ul, li {
        margin: 0px;
        list-style: none;
        padding: 0px;
    }

    .contain {
        height: 209.8mm;
        position: relative;
        user-select: none;
        width: 352mm;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 7px;
    }

    .drag {
        //width: 100px;
        //height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        cursor: move;
        background-color: red;
        border: 1px solid #FFF;
        //line-height: 1.7;
        box-sizing: border-box;
        color: #fff;
        overflow: hidden;
        //padding: 5px;

        .sacle {
            position: absolute;
            right: 0px;
            bottom: 0px;
            background-color: #909399;
            cursor: se-resize;
            font-size: 15px;
        }

        .del {
            position: absolute;
            top: 0px;
            right: 0px;
            padding: 2px;
            box-shadow: none;
        }
    }

    .drag.active {
        border-radius: 5px;
        border: 1px solid #85ce61;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

    }

    .control {
        width: 250px;
        border-radius: 5px;
        overflow: hidden;
        background-color: #B3C0D1;
        position: absolute;
        z-index: 999;
        right: 20px;
        top: 15px;
    }
</style>

